import gql from 'graphql-tag'

export const GET_DI_FROM_ORGID = gql`
  mutation getDiCodeFromOrgId($loginTimestamp: String!) {
    getDiCodeFromOrgId(loginTimestamp: $loginTimestamp)
  }
`

export const UPDATE_INSTITUTION_ADMIN = gql`
  mutation updateInstitutionAdmin($di_code: String!, $attrs: JSON!) {
    updateInstitutionAdmin(di_code: $di_code, attrs: $attrs)
  }
`

export const CREATE_AGG_FILE = gql`
  mutation createAggFile($entryTerms: [Int!]!) {
    createAggFile(entryTerms: $entryTerms)
  }
`

export const CREATE_AGG_FILE_ADMIN = gql`
  mutation createAggFileAdmin($entryTerms: [Int!]!, $di_code: String!) {
    createAggFileAdmin(entryTerms: $entryTerms, di_code: $di_code)
  }
`

export const DELETE_AGG_FILE = gql`
  mutation deleteAggFile($fileName: String) {
    deleteAggFile(fileName: $fileName)
  }
`

export const ADD_INSTITUTION_ADMIN = gql`
  mutation addInstitutionAdmin($di_code: String!, $institutionName: String!, $org_id: String!) {
    addInstitutionAdmin(di_code: $di_code, institutionName: $institutionName, org_id: $org_id)
  }
`
export const CREATE_HIST_REPORT_ADMIN = gql`
  mutation createHistoricalReportAdmin($input: HistoricalReportCreateInput!) {
    createHistoricalReportAdmin(input: $input)
  }
`

export const CREATE_INSTITUTION_PREFERENCE = gql`
  mutation createPreference($input: CreatePreferenceInput!) {
    createPreference(input: $input)
  }
`

export const CREATE_INSTITUTION_PREFERENCE_ADMIN = gql`
  mutation createPreferenceAdmin($input: CreatePreferenceAdminInput!) {
    createPreferenceAdmin(input: $input)
  }
`

export const DELETE_HIST_REPORT_ADMIN = gql`
  mutation deleteHistoricalReportAdmin($input: HistoricalReportDeleteInput!) {
    deleteHistoricalReportAdmin(input: $input)
  }
`

export const UPDATE_QC_REVIEW_STATUSES = gql`
  mutation updateQCReviewStatuses($input: [UpdateQCReviewStatusesInputType!]) {
    updateQCReviewStatuses(input: $input)
  }
`
